import httpBuildQuery from '../../../procedures/http-build-query';
import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/banking-operations`;
export const modelName = 'bankingoperations';

export default {
  ...apiCrud({ baseUri, modelName }),
  indexNotSettled: async (query) => await axios.get(`${ baseUri }/index-not-settled${ httpBuildQuery(query) }`),
  settle: async (data) => await axios.post(`${ import.meta.env.VITE_SITE_URL }/open-banking/bank-operations/settle`, data),
};
